import React from 'react'
import Advertisement from './Advertisement'
import './advertises.css'
import EditorsPick from './EditorsPick'
import data from '../FakeData/index.json'
import UseFetch from '../UseFetch'
import Topics from './Topics'
import mainData from '../FetchDataLinks'
import EditorsPickSkeleton from './EditorsPickSkeleton'

function AdvertiseAndEditorsPick({ url }) {

    let a = 0;

    const { blogs, loading } = UseFetch(mainData.editorsPick)

    return (
        <div className="w3l-homeblock2 py-5">
            <div className="container py-lg-5 py-md-4">
                <div className="row">
                    <div className="col-lg-8">
                        <h3 className="section-title-left mb-4"> Editor's Pick </h3>
                        <div className="row">
                            {loading && Array(2).fill().map(() => {
                                a++;
                                return <EditorsPickSkeleton key={`editorsPickSkeleton${a}`} />
                            })}
                            {!loading && blogs.map((blog) => {
                                return <EditorsPick key={blog.id} cateogary={blog.Cateogary} image={blog.Image} slug={blog.slug} PostHead={blog.Headline} PostContent={blog.Content} time={blog.Time} AuthorName={data[0].authorName} date={blog.date} />
                            })}
                        </div>
                        {url && <Advertisement key={`world`} />}
                    </div>
                    <Topics />
                </div>
            </div>
        </div>

    )
}

export default AdvertiseAndEditorsPick
